// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nx-0";
export var fileList = "_nx-2";
export var removeFileButton = "_nx-1";